export const navigateTo = (path) => {
  const id = path.replace("/", "").replace("#", "") || "home";
  const element = document.getElementById(id);
  element && element.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const navigateHandler = (e) => {
  let linkEl;
  if (e.target.tagName !== "A") {
    linkEl = e.target.closest("a");
  } else {
    linkEl = e.target;
  }
  const url = linkEl.href.split("/");
  navigateTo(url[url.length - 1]);
};
